const errorMessages = {
  accountNotVerified:
    'Account could not be verified. Please double-check entered fields and try again.',
  accountAlreadyRegistered: 'Account Already Registered.',
  deficitInvoiceTotalErrorMessage: 'Payment total cannot be less than $1.00.',
  exceedCurrentBalanceErrorMessage:
    'Your total scheduled payments cannot exceed your current balance.',
  exceedInvoiceTotalErrorMessage:
    'Amount to be paid cannot exceed the invoice total.',
  exceedAmountToApplyErrorMessage:
    'Amount to be paid cannot exceed the amount to apply.',
  invalidAuthorizationCode: 'Invalid Authentication code.',
  invalidAccountCredentials:
    'We don’t recognize this User ID and Password combination. Please double-check entered fields and try again.',
  invalidDecimalMessage: 'Enter a valid amount up to 2 decimal places.',
  invalidEmailId: 'Invalid Email Address.',
  invalidEmailLength: 'Email address cannot exceed the maximum length of 50.',
  invalidMonthDuration:
    'Amount of time between From and To date cannot be greater than 12 months.',
  exceedCurrentMonth: 'Month cannot be greater than Present Date',
  invalidName: 'Invalid Name',
  invalidPhoneNumber: 'Phone Number must be 10 digits.',
  invalidZIPCode: 'ZIP Code must be 5 digits.',
  invalidUserId: 'Invalid User ID.',
  invalidAccountNumber: 'Invalid Account Number.',
  invalidYearDuration: 'From year cannot be greater than To year.',
  invalidPassword: 'Invalid Password',
  recordsDontMatch: 'The password you entered does not match our records.',
  lastTenPasswordsCannotBeUsed:
    'You may not reuse any of your previous 10 passwords for this user.',
  invalidAmount: 'Invalid Amount',
  invalidAmountMinimum: 'Amount to Pay must be more than $1.00.',
  invalidAnswer:
    'Answer provided does not match our records. Please try again.',
  invalidBusinessRevenueAmount: 'Business Revenue must be more than $1.',
  isRequired: 'is required.',
  monthDifferenceErrorMessage: 'From month cannot be greater than To month',
  noMatchEmail: 'The Email does not match',
  notMatchErrorMessage: 'The password does not match',
  notMatchUserID: 'User IDs do not match.',
  previouslyLinkedUserId:
    'An Account with this User ID is already linked to your profile.',
  statementUnavailableOnBrowser:
    'Online statement view isn’t available in this browser. Please download a .pdf to view this statement.',
  statementUnavailableOnDevice:
    'Online statement view isn’t available on low resolution screens or devices. Please download a .pdf to view this statement.',
  userAvailable: 'This User ID is available.',
  userNotRegistered: 'User is not registered.',
  userUnavailable: 'This User ID is unavailable.',
  underCreditErrorMessage:
    'Desired Credit line is less than or equal to current credit line.'
} as const

export default errorMessages
